import { Component } from '@angular/core';
import { BookDemoService } from '../../../dialogs/book-demo-dialog/book-demo.service';

@Component({
  selector: 'app-ts-v2-ranking-section',
  templateUrl: './ranking-section.component.html',
  styleUrls: ['./ranking-section.component.scss'],
})
export class V2RankingSectionComponent {
  constructor(private bookDemo: BookDemoService) {}

  openBookDemo(): void {
    this.bookDemo.open();
  }
}
